import React, { useEffect } from 'react'

const Step4 = ({formData,setFormData}) => {
  const q7 = ["חפץ חם", "חפץ חשמלי", "מים", "חשיפה לאש","אחר"]
  const q8 = ["היום", "שעה קלה לפני ההגעה לבית החולים", "לפני מספר ימים", "לפני מעל חודש (סיבוך בכוויה)"]
    useEffect(() => {
          console.log(formData)
      }, [formData])
  return (
    <div className='w-full flex flex-col ' style={{direction:"rtl"}}>
       <p className='text-right'>7. גורם לכוויה?</p>
            {q7.map((q, index) => (
                <div key={index} className="flex items-center gap-2 mt-1">
                    <input
                        type='radio'
                        name='selectq7 '
                        value={q}
                        id={`q7-${index}`}
                        checked={formData.q7 === q}
                        onChange={(e) => {
                            const selected = e.target.value;
                            setFormData({
                                ...formData,
                                q7: selected,
                                q7Other: selected === "אחר" ? formData.q7Other : ""
                            });
                        }}
                    />
                     {q === "אחר" && formData.q7 === "אחר" ? (
                        <input
                            type='text'
                            className='text-Black bg-LightBlue rounded-lg border-2 p-2 border-MidBlue outline-none'
                            placeholder='טקסט חופשי'
                            value={formData.q7Other}
                            onChange={(e) => setFormData({ ...formData, q7Other: e.target.value })}
                        />
                    ) : (
                        <label htmlFor={`q7-${index}`}>{q}</label>
                    )}

                </div>
            ))}
             <p className='text-right'>8. מתי התרחשה החבלה?</p>
            {q8.map((q, index) => (
                <div key={index} className="flex items-center gap-2 mt-1">
                    <input
                        type='radio'
                        name='selectq8'
                        value={q}
                        id={`q8-${index}`}
                        checked={formData.q8 === q}
                        onChange={(e) => {
                            const selected = e.target.value;
                            setFormData({
                                ...formData,
                                q8: selected,
                                // q5Other: selected === "אחר" ? formData.q5Other : ""
                            });
                        }}
                    />
                    <label htmlFor={`q8-${index}`}>{q}</label>
                </div>
            ))}
       </div>
  )
}

export default Step4